module.exports = __webpack_public_path__ + "img/arrow-magenta.65bdc624.svg";